// removed by extract-text-webpack-plugin
module.exports = {"lecture_section":"_3X98_QrTdaB019reWwRqWQ","date-setting-section":"_34nUiM7_HNx2D7mdtYtY7F","date-setting-formGroup":"_2MkaVpEesAkGcRixFXk_20","date-input-field":"_122nEW4w-aZxS5Wcr5PFMy","date-input":"_3lfoJsNkVZa786lY2-Q_ol","date-preview":"vhyE3L0VgMjyijDccFY5H"};


//////////////////
// WEBPACK FOOTER
// ./src/pages/LecturePage/lecture-date-setting.scss
// module id = 1333
// module chunks = 0